module.exports = __webpack_public_path__ + "static/media/team-francis.827a45d2.jpg";